<div>
    <div class="w-12 my-1">
        <button pButton class="w-3 h-2rem md:text-sm px-0" label="Project"></button>
        <p-multiSelect styleClass="md:text-sm h-2rem w-9" panelStyleClass="text-sm px-0" [filter]="true"
            placeholder="Select Project(s)" [options]="projectList" optionLabel="label" optionValue="value"
            [showClear]="true" name="projectList" [(ngModel)]="selectedProjects"
            (onChange)="populateAllLists()" (onSelectAllChange)="populateAllLists()" (onClear)="populateAllLists()">
        </p-multiSelect>
	</div>
	<div class="w-12 my-1" *ngIf="showProtocolFilter">
        <button pButton class="w-3 h-2rem md:text-sm px-0" label="Protocol"></button>
        <p-multiSelect styleClass="md:text-sm h-2rem w-9" panelStyleClass="text-sm px-0" [filter]="true"
            placeholder="Select Protocol(s)" [options]="protocolList" optionLabel="label" optionValue="value"
            [showClear]="true" name="protocolList" [(ngModel)]="selectedProtocolWorkflows"
            (onChange)="populateAllLists()" (onSelectAllChange)="populateAllLists()" (onClear)="populateAllLists()">
        </p-multiSelect>
	</div>
	<div class="w-12 my-1" *ngIf="showDateFilter">
		<button pButton class="w-3 h-2rem md:text-sm px-0" label="From Date"></button>
		<p-calendar [(ngModel)]="fromDate" appendTo="body" styleClass="w-9 md:text-sm h-2rem px-0" readonlyInput="true" (onSelect)="populateAllLists()"
			dateFormat="dd.mm.yy" [showIcon]="true" placeholder="Sel. Start Date" showButtonBar="true"
			(onClearClick)="populateAllLists()" (onTodayClick)="populateAllLists()">
		</p-calendar>
	</div>
	<div class="w-12 my-1" *ngIf="showDateFilter">
		<button pButton class="w-3 h-2rem md:text-sm px-0" label="To Date"></button>
		<p-calendar [(ngModel)]="toDate" appendTo="body" styleClass="w-9 md:text-sm h-2rem px-0" readonlyInput="true" (onSelect)="populateAllLists()"
			dateFormat="dd.mm.yy" [showIcon]="true" placeholder="Sel. End Date" showButtonBar="true"
			(onClearClick)="populateAllLists()" (onTodayClick)="populateAllLists()">
		</p-calendar>
	</div>
</div>

<p-panel id="array-table" header="Array" [toggleable]="true" [collapsed]="true" *ngIf="this.showArraysTable()" class="p-2" [style]="{'height':'unset !important','display':'grid'}">
    <div name="array-list" [ngClass]="getArrayListDivClasses()">
        <div class="w-12 my-2">
            <button pButton class="w-3 h-2rem md:text-sm px-0" label="Status"></button>
            <p-multiSelect styleClass="md:text-sm h-2rem w-9" panelStyleClass="text-sm px-0" [filter]="true" optionLabel="name"
                           [options]="availableArrayStatuses" [(ngModel)]="selectedArrayStatuses" (onChange)="getArrayList()"
                           placeholder="Filter Statuses" [showClear]="true" filterBy="name">
            </p-multiSelect>
        </div>
        <div class="w-12 mt-2 flex justify-content-between">
            <span class="mx-1">Arrays Count : {{arrays.length}}</span>
            <span class="mx-1">Show Due Date <p-inputSwitch [(ngModel)]="showDueDate"></p-inputSwitch> </span>
        </div>
        <p-table [value]="arrays" selectionMode="single" [(selection)]="selectedPlate" (onRowSelect)="fetchPlate($event)" (onRowUnselect)="removeSelection()" [scrollable]="true" [scrollHeight]="getTableScrollHeight()" [tableStyle]="{ 'min-width': '60%' }" [loading]="arraysTableLoader" styleClass="p-datatable-striped my-2 mx-1 md:text-sm lg:text-md">
            <ng-template pTemplate="header">
                <tr>
                    <th scope="col" class="py-1 text-center">
                        <b>Array-ID</b><span *ngIf="showDueDate"> (Due Date)</span><br/>
                        Status
                    </th>
                </tr>
            </ng-template>
            <ng-template pTemplate="body" let-array>
                <tr [pSelectableRow]="array">
                    <td class="py-1 text-break text-center">
                        <b>{{ array.lastUpdatedPlateID }}</b><span *ngIf="showDueDate"> ( {{ convertUtcToLocal(array.dueDate) | date:'dd.MM.yyyy' }} )</span><br/>
                        {{ array.status }}
                    </td>
                </tr>
            </ng-template>
        </p-table>
    </div>
</p-panel>

<p-panel id="plate-table" header="Plates" [toggleable]="true" [collapsed]="true" *ngIf="showPlatesTable()" class="p-2" [style]="{'height':'unset !important','display':'grid'}">
    <div name="plate-list" class="h-fit" [ngClass]="getPlateListDivClasses()">
        <div class="w-12 my-1">
            <button pButton class="w-3 h-2rem md:text-sm px-0" label="Status"></button>
            <p-multiSelect styleClass="md:text-sm h-2rem w-9" panelStyleClass="text-sm px-0" [filter]="true" optionLabel="name"
                           [options]="availableStatuses" [(ngModel)]="selectedStatuses" (onChange)="getPlateList()"
                           placeholder="Filter Statuses" [showClear]="true" filterBy="name" (onSelectAllChange)="getPlateList()" (onClear)="getPlateList()">
            </p-multiSelect>
        </div>

        <div class="w-12 mt-2 flex justify-content-between">
            <span class="mx-1">Plates Count : {{plates.length}}</span>
            <span class="mx-1">Show Due Date <p-inputSwitch [(ngModel)]="showDueDate"></p-inputSwitch> </span>
        </div>
        <p-table [value]="plates" selectionMode="single" [(selection)]="selectedPlate" (onRowSelect)="fetchPlate($event)" (onRowUnselect)="removeSelection()" [scrollable]="true" [scrollHeight]="getTableScrollHeight()" [tableStyle]="{ 'min-width': '60%' }" [loading]="platesTableLoader" styleClass="p-datatable-striped mt-2 mx-1 md:text-sm lg:text-md">
            <ng-template pTemplate="header">
                <tr>
                    <th scope="col" class="py-1 text-center">
                        <b>Plate-ID</b><span *ngIf="showDueDate"> (Due Date)</span><br/>
                        Status
                    </th>
                </tr>
            </ng-template>
            <ng-template pTemplate="body" let-plate>
                <tr [pSelectableRow]="plate">
                    <td class="py-1 text-break text-center">
                        <b>{{ plate.lastUpdatedPlateID }}  
                            <i *ngIf="plate?.reRun" class="pi pi-star-fill"></i>
                            <i class="pi pi-arrow-right-arrow-left p-1" *ngIf="checkStatusChange(plate)"></i></b>
                        <span *ngIf="showDueDate">
                        ( {{ convertUtcToLocal(plate.dueDate) | date:'dd.MM.yyyy' }} )
                    </span>
                        <i *ngIf="plate?.latestUserComment" class="pi pi-comment pl-1" [pTooltip]="showLatestComment(plate,datePipe)"></i>
                        <i *ngIf="plate?.batchID" class="pi pi-inbox pl-1"  pTooltip="This plate is batched under the ID: {{plate?.batchID}}"></i>
                        <br/>
                        {{ plate.status }}
                    </td>
                </tr>
            </ng-template>
        </p-table>
    </div>
</p-panel>

<p-panel id="batch-table" header="Batches" [collapsed]="true" [toggleable]="true" *ngIf="showBatchesTable()" class="p-2" [style]="{'height':'unset !important','display':'grid'}">
    <div name="batch-list" [ngClass]="getBatchListDivClasses()">
        <div class="w-12 my-2">
            <button pButton class="w-3 h-2rem md:text-sm px-0" label="Status"></button>
            <p-multiSelect styleClass="md:text-sm h-2rem w-9" panelStyleClass="text-sm px-0" [filter]="true" optionLabel="name"
                           [options]="availableBatchStatuses" [(ngModel)]="selectedBatchStatuses" (onChange)="getBatchList()"
                           placeholder="Filter Statuses" [showClear]="true" filterBy="name">
            </p-multiSelect>
        </div>
        <div class="w-12 mt-2 flex justify-content-between">
            <span class="mx-1">Batch Count : {{batches.length}}</span>
            <span class="mx-1">Show Due Date <p-inputSwitch [(ngModel)]="showDueDate"></p-inputSwitch> </span>
        </div>
        <p-table [value]="batches" selectionMode="single" [(selection)]="selectedPlate" (onRowSelect)="fetchBatch($event)" (onRowUnselect)="removeSelection()" [scrollable]="true" [scrollHeight]="getTableScrollHeight()" [tableStyle]="{ 'min-width': '60%' }" [loading]="batchesTableLoader" styleClass="p-datatable-striped my-2 mx-1 md:text-sm lg:text-md">
            <ng-template pTemplate="header">
                <tr>
                    <th scope="col" class="py-1 text-center">
                        <b>Batch-ID</b><span *ngIf="showDueDate"> (Due Date)</span><br/>
                        Status
                    </th>
                </tr>
            </ng-template>
            <ng-template pTemplate="body" let-batch>
                <tr [pSelectableRow]="batch">
                    <td class="py-1 text-break text-center">
                        <b>{{ batch.batchID }}</b>
                        <span *ngIf="showDueDate"> ( {{ convertUtcToLocal(batch.dueDate) | date:'dd.MM.yyyy' }} )</span>
                        <i class="pi pi-bars pl-1"  pTooltip="Plates:{{'\n'}}{{batch?.plates.join('\n')}}"></i>
                        <br/>
                        {{ batch.status }}
                    </td>
                </tr>
            </ng-template>
        </p-table>
    </div>
</p-panel>
<p-panel id="run-table" header="Runs" class="p-2" [collapsed]="false" [toggleable]="true" *ngIf="showRunTable()"
    [style]="{'height':'unset !important','display':'grid'}">
    <div name="run-list" class="height-45">
        <div class="w-12 my-1">
            <button pButton class="w-4 h-2rem md:text-sm px-0" label="Status"></button>
            <p-multiSelect styleClass="md:text-sm h-2rem w-8" panelStyleClass="text-sm px-0" [filter]="true"
                optionLabel="name" [options]="availableRunStatuses" [(ngModel)]="selectedStatuses"
                (onChange)="fetchRuns()" placeholder="Filter Statuses" [showClear]="true" filterBy="name"
                (onSelectAllChange)="fetchRuns()" (onClear)="fetchRuns()">
            </p-multiSelect>
        </div>

        <div class="w-12 mt-2 flex justify-content-between">
            <span class="mx-1">Run Count : {{runs.length}}</span>
        </div>
        <p-table [value]="runs" selectionMode="single" [(selection)]="selectedPlate" (onRowSelect)="fetchRun($event)"
            (onRowUnselect)="removeSelection()" [scrollable]="true" [scrollHeight]="getTableScrollHeight()"
            [tableStyle]="{ 'min-width': '60%' }" [loading]="platesTableLoader"
            styleClass="p-datatable-striped mt-2 mx-1 md:text-sm lg:text-md">
            <ng-template pTemplate="header">
                <tr>
                    <th scope="col" class="py-1 text-center">
                        <b>Run-ID</b><span *ngIf="showDueDate"> (Due Date)</span><br />
                        Status
                    </th>
                </tr>
            </ng-template>
            <ng-template pTemplate="body" let-run>
                <tr [pSelectableRow]="run">
                    <td class="py-1 text-break text-center">
                        <b>{{ run.runId }}</b>
                        <br />
                        {{ run.status }}
                    </td>
                </tr>
            </ng-template>
        </p-table>
    </div>
</p-panel>